'use client';

import { AppBar, Box, Container, Toolbar } from '@mui/material';
import React from 'react';
import { useLayoutHeader } from '@/hooks/useLayoutHeader';
import NextLink from '@/components/link/NextLink';
import Logo from '@/../public/logo_normal.png';
import { MuiButton } from '@/components/button/MuiButton';
import { PublicMenuBar } from './PublicMenuBar';

export function PublicHeader() {
  const headerElement = React.useRef<HTMLElement>(null);
  const { useHeaderResizeEffect } = useLayoutHeader();

  useHeaderResizeEffect(headerElement);

  return (
    <AppBar
      ref={headerElement}
      position="fixed"
      sx={{
        top: 0,
        zIndex: (theme) => theme.zIndex.drawer + 1,
        bgcolor: '#FFFFFF',
        color: '#13131D',
        borderBottom: '1px solid #FFF3B2',
        boxShadow: '0px 0.5px 2px 0px #0000001A, 0px 0px 2px 0px #0000001A',
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ justifyContent: 'space-between' }}>
          <Box sx={{ display: 'flex', alignItems: 'center' }}>
            <PublicMenuBar isPC={false} />
            <NextLink
              href="/public"
              underline="hover"
              color="inherit"
              sx={{
                cursor: 'pointer',
                display: 'block',
                height: '64px',
                '@media (max-width: 600px)': { height: '56px' },
              }}
            >
              <Box
                component="img"
                src={Logo.src}
                alt="けあログっとロゴ"
                sx={{
                  minWidth: '145px',
                  height: '64px',
                  '@media (max-width: 600px)': { height: '56px' },
                }}
              />
            </NextLink>
          </Box>
          <PublicMenuBar isPC={true} />
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
            <MuiButton href="/signin">ログイン</MuiButton>
          </Box>
        </Toolbar>
      </Container>
    </AppBar>
  );
}
